import axios from "axios";

const cache = new Map();
const inFlightRequests = new Map();

/**
 * Enterprise Cached HTTP Client
 * Prevents redundant network trips and deduplicates concurrent requests.
 */
export async function getCached(url, fallback) {
    if (cache.has(url)) {
        return cache.get(url);
    }

    if (inFlightRequests.has(url)) {
        return inFlightRequests.get(url);
    }

    const requestPromise = axios
        .get(url)
        .then((res) => {
            cache.set(url, res.data);
            inFlightRequests.delete(url);
            return res.data;
        })
        .catch((err) => {
            console.error(`[Service Error] Fetching ${url}:`, err.message);
            inFlightRequests.delete(url);
            return fallback;
        });

    inFlightRequests.set(url, requestPromise);
    return requestPromise;
}

export function getFromCache(url) {
    return cache.get(url) || null;
}

export function isCached(url) {
    return cache.has(url);
}

export function clearCache() {
    cache.clear();
}
